module.exports = __webpack_public_path__ + "media/src/images/favicon/favicon-32x32-ec2da5b9de7341f9d729bb7e61738290.png";